import t9n from "@bimproject/t9n";
import { useTranslation } from "react-i18next";

import ParameterCard from "./ParameterCard";
import useSuspenseParameter from "../../../../../../clients/taxonomy/useParameter";

export default function ParameterCardContainer(props) {
    const { Component = ParameterCard, id, ...restProps } = props;

    const { i18n } = useTranslation();

    const parameter = useSuspenseParameter(id).data?.parameter;

    return (
        <Component
            name={ t9n(parameter.name, i18n.language) }
            type={
                parameter.values?.length
                    ? {
                        number: "number",
                        text: "text",
                    }[parameter.dataType]
                    : undefined
            }
            { ...restProps }
        />
    );
}
